export enum PropertyType {
  APPARTAMENTO = 'APPARTAMENTO',
  CASA_INDIPENDENTE = 'CASA_INDIPENDENTE',
  ATTICO = 'ATTICO',
  MANSARDA = 'MANSARDA',
  LOFT = 'LOFT',
  VILLA = 'VILLA',
  VILLETTA_A_SCHIERA = 'VILLETTA_A_SCHIERA',
  RUSTICO_CASALE = 'RUSTICO_CASALE',
  PALAZZO = 'PALAZZO',
}

export const propertyTypesWithoutFloor = [
  PropertyType.VILLA,
  PropertyType.VILLETTA_A_SCHIERA,
  PropertyType.CASA_INDIPENDENTE,
  PropertyType.PALAZZO,
  PropertyType.RUSTICO_CASALE,
];
